import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap"
import PropTypes from "prop-types"
import axios from "axios";
import Swal from "sweetalert2";

const ModalComanda = (props) => {
    // const [comandas,] = useState([
    //     {
    //       id: 1,
    //       mesa: 5,
    //       categoria: 'Cocina',
    //       articulos: [
    //         { nombre: 'Hamburguesa Clásica', cantidad: 2, precio: 12.50, notas: 'Sin cebolla' },
    //         { nombre: 'Papas Fritas', cantidad: 1, precio: 4.50, notas: '' },
    //         { nombre: 'Ensalada César', cantidad: 1, precio: 8.00, notas: 'Aderezo aparte' }
    //       ],
    //       hora: '14:30',
    //       mesero: 'Juan Pérez'
    //     },
    //     {
    //       id: 2,
    //       mesa: 5,
    //       categoria: 'Bar',
    //       articulos: [
    //         { nombre: 'Cerveza Corona', cantidad: 3, precio: 3.50, notas: '' },
    //         { nombre: 'Mojito', cantidad: 1, precio: 8.00, notas: 'Extra menta' },
    //         { nombre: 'Agua Mineral', cantidad: 2, precio: 2.00, notas: '' }
    //       ],
    //       hora: '14:25',
    //       mesero: 'Juan Pérez'
    //     },
    //     {
    //       id: 3,
    //       mesa: 5,
    //       categoria: 'Postres',
    //       articulos: [
    //         { nombre: 'Tiramisú', cantidad: 1, precio: 6.50, notas: '' },
    //         { nombre: 'Helado de Vainilla', cantidad: 2, precio: 4.00, notas: 'Con chocolate' }
    //       ],
    //       hora: '15:45',
    //       mesero: 'Juan Pérez'
    //     }
    // ]);
    const [comandas,setComandas] = useState([]);

    const [,setIsRePrint] = useState(false);

    useEffect(()=>{
        if ( !props.visible )
        {
            setIsRePrint(false)
            props.setAccountComandaSelected(null)
        }
    },[props.visible])

    useEffect(()=>{
        setComandas(props.comandas);
    },[props.comandas])

    const comandasPorCategoria = comandas.reduce((acc, comanda) => {
    if (!acc[comanda.sub_category_des]) {
        acc[comanda.sub_category_des] = [];
    }
    acc[comanda.sub_category_des].push(comanda);
    return acc;
    }, {});

    const categorias = Object.keys(comandasPorCategoria);
    const tieneUnaCategoria = categorias.length === 1;

    // Función para imprimir todas las categorías
    const imprimirTodas = async() => {
        console.log('comandasPorCategoria>>',comandasPorCategoria)
        for ( const category in comandasPorCategoria )
        {
            console.log('cat>>',category, comandasPorCategoria)

            imprimirCategoria(category)
        }
    }
    // const imprimirTodas = () => {    
    //     let contenido = `
    //         <div style="font-family: Arial, sans-serif; max-width: 300px; margin: 0 auto;">
    //             <div style="text-align: center; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 15px;">
    //                 <h2 style="margin: 5px 0; font-size: 18px;">COMANDA</h2>
    //             </div>

    //             <div style="margin-bottom: 20px; border-bottom: 1px solid #ccc; padding-bottom: 15px;">

    //                 <div style="display: flex; justify-content: space-between; font-weight: bold; margin-bottom: 10px;">
    //                     <span>Mesa: ${comandasPorCategoria[categorias[0]][0].mesa_des}</span>
    //                     <span>Hora: ${comandasPorCategoria[categorias[0]][0].account_time}</span>
    //                 </div>

    //                 <div style="margin-bottom: 10px;"><strong>Cliente:</strong> ${comandasPorCategoria[categorias[0]][0].customer_name}</div>

    //                 <table style="width: 100%; border-collapse: collapse;">
    //                         <thead>
    //                             <tr style="border-bottom: 1px solid #000;">
    //                                 <th style="text-align: left; padding: 5px 0;">Artículo</th>
    //                                 <th style="text-align: center; padding: 5px 0;">Cant.</th>
    //                             </tr>
    //                         </thead>
    //                         <tbody>
    //         `;

    //     categorias.forEach((categoria) => {
    //         comandasPorCategoria[categoria].forEach(comanda => {                
    //             comanda.items.forEach(articulo => {
    //                 contenido += `
    //                     <tr>
    //                         <td style="padding: 3px 0;">
    //                         <strong>${articulo.product_des}</strong>
    //                         ${articulo.additionals ? `<br><small style="color: #666;">${articulo.additionals}</small>` : ''}
    //                         ${articulo.item_note ? `<br><small style="color: #666;">Nota: ${articulo.item_note}</small>` : ''}
    //                         </td>
    //                         <td style="text-align: center; padding: 3px 0;">${articulo.qty} ${articulo.unit_des.toUpperCase()}</td>
    //                     </tr>
    //                 `;
    //             });
    //         });
    //     });

    //     contenido += `
    //                     </tbody>
    //                 </table>
    //             </div>
    //             <div style="text-align: center; margin-top: 20px; font-size: 12px; color: #666;">
    //                 <p>Impreso: ${new Date().toLocaleString('es-ES')}</p>
    //             </div>
    //         </div>
    //     `;

    //     // Abrir ventana de impresión
    //     const ventanaImpresion = window.open('', '_blank');
    //     ventanaImpresion.document.write(`
    //     <html>
    //         <head>
    //         <title>Comanda - Restaurante</title>
    //         <style>
    //             @media print {
    //             body { margin: 0; }
    //             @page { margin: 10mm; }
    //             }
    //         </style>
    //         </head>
    //         <body>
    //         ${contenido}
    //         </body>
    //     </html>
    //     `);
    //     ventanaImpresion.document.close();
    //     ventanaImpresion.print();

    // };

    // const calcularTotalCategoria = (categoria) => {
    //     return comandasPorCategoria[categoria].reduce((total, comanda) => {
    //     return total + comanda.articulos.reduce((subtotal, articulo) => {
    //         return subtotal + (articulo.precio * articulo.cantidad);
    //     }, 0);
    //     }, 0);
    // };

    // const calcularTotalGeneral = () => {
    //     return comandas.reduce((total, comanda) => 
    //     total + comanda.articulos.reduce((subtotal, articulo) => 
    //         subtotal + (articulo.precio * articulo.cantidad), 0), 0
    //     );
    // };

    // Función para imprimir una categoría específica
    const imprimirCategoria = async (categoria) => {
        const id = props.accountComandaSelected;
        const comandasCategoria = comandasPorCategoria[categoria];
        try {
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'put/order/prepared/comandas',{
                comandasCategoria: comandasCategoria,
                account: id,
                token: localStorage.getItem('OSHEN-LOC-STR-TK')
            }),
            data = resource.data;
            console.log('data>>',data)
            if ( !data.status ) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Advertencia',
                    text: "La comanda será impresa pero los artículos no pudieron ser marcados como impresos, por favor comunica esta situación"
                }).then(()=>{
                    sendPrintComanda(comandasCategoria, categoria)
                    props.setVisible(false)
                });
                return;
            }
            sendPrintComanda(comandasCategoria, categoria)
            // props.setVisible(false)
            props.setComandas(data.comandas)
        } catch ( e ) {
            console.log('::::e::::', e)
        }
        
    };

    const sendPrintComanda = (comandasCategoria, categoria) => {
        // Crear contenido para imprimir
        let contenido = `
        <div style="font-family: Arial, sans-serif; max-width: 300px; margin: 0 auto;">
            <div style="text-align: center; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 15px;">
            <h2 style="margin: 5px; font-size: 18px;">COMANDA</h2>
            <h3 style="margin: 5px 0; font-size: 16px; text-transform: uppercase;">${categoria}</h3>
            </div>
        `;

        comandasCategoria.forEach(comanda => {
        contenido += `
            <div style="margin-bottom: 20px; border-bottom: 1px solid #000; padding-bottom: 15px;">
            <div style="display: flex; justify-content: space-between; font-weight: bold; margin-bottom: 10px;">
                <span style="color: #000 !important;">Cuenta: #${comanda.quote_no?comanda.quote_no:comanda.quotation_id}</span>
            </div>
            <div style="display: flex; justify-content: space-between; font-weight: bold; margin-bottom: 10px;">
                <span style="color: #000 !important;">Mesero: ${comanda.created_by}</span>
            </div>
            <div style="display: flex; justify-content: space-between; font-weight: bold; margin-bottom: 10px;">                
                <span style="color: #000 !important;">Area: ${comanda.mesa_des}</span>
                <span style="color: #000 !important;">Hora: ${comanda.account_time}</span>
            </div>
            <div style="margin-bottom: 10px;color: #000 !important;"><strong>Cliente:</strong> ${comanda.customer_name}</div>
            
            <table style="width: 100%; border-collapse: collapse;">
                <thead>
                <tr style="border-bottom: 1px solid #000;">
                    <th style="text-align: left; padding: 5px 0;color: #000 !important;">Artículo</th>
                    <th style="text-align: center; padding: 5px 0;color: #000 !important;">Cant.</th>
                </tr>
                </thead>
                <tbody>
        `;
        
        comanda.items.forEach(articulo => {
            contenido += `
            <tr>
                <td style="padding: 3px 0;color: #000 !important;">
                <strong>${articulo.product_des}</strong>
                ${articulo.additionals ? `<br><span style="color: #000 !important;">${articulo.additionals}</span>` : ''}
                ${articulo.item_note ? `<br><span style="color: #000 !important;"><strong>NOTA</strong>: ${articulo.item_note}</span>` : ''}
                </td>
                <td style="text-align: center; padding: 3px 0;color: #000 !important;">${articulo.qty} ${articulo.unit_des.toUpperCase()}</td>
            </tr>
            `;
        });
        
        contenido += `
                </tbody>
            </table>
            </div>
        `;
        });

        contenido += `
            <div style="text-align: center; margin-top: 20px; font-size: 12px; color: #000 !important;">
            <p>Impreso: ${new Date().toLocaleString('es-ES')}</p>
            </div>
        </div>
        `;

        // Abrir ventana de impresión
        const ventanaImpresion = window.open('', `_blank${categoria}`);
        ventanaImpresion.document.write(`
        <html>
            <head>
            <title>Comanda - ${categoria}</title>
            <style>
                @media print {
                    body { margin: 0; }
                    @page { margin: 10mm; }
                    #botones-acciones { display: none; }
                }
            </style>
            </head>
            <body>
                ${contenido}

                <div id="botones-acciones" style="text-align: center; margin-top: 30px;">
                    <button onclick="window.print()" style="
                        background-color: #28a745;
                        color: white;
                        border: none;
                        padding: 10px 20px;
                        font-size: 14px;
                        border-radius: 5px;
                        margin-right: 10px;
                        cursor: pointer;
                    ">
                        Re-imprimir
                    </button>
                    <button onclick="window.close()" style="
                        background-color: #dc3545;
                        color: white;
                        border: none;
                        padding: 10px 20px;
                        font-size: 14px;
                        border-radius: 5px;
                        cursor: pointer;
                    ">
                        Cerrar
                    </button>
                </div>

            </body>
        </html>
        `);
        ventanaImpresion.document.close();
        ventanaImpresion.print();
        // Esperar a que la ventana termine de cargar antes de imprimir
        // ventanaImpresion.onload = function () {
        //     ventanaImpresion.focus();
        //     ventanaImpresion.print();
        // };
    }

    const getRePrintComandas = async(input) => {
        input.preventDefault();
        const id = props.accountComandaSelected;
        try {
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'get/re/print/comandas',{
                account: id,
                token: localStorage.getItem('OSHEN-LOC-STR-TK')
            }),
            data = resource.data;
            /* eslint-disable-next-line react/prop-types */
            props.setComandas(data);
            //
            setIsRePrint(true);
        } catch ( err ) {
            console.log('err->', err)
        }
    }

    return (
        <Modal size="lg" show={props.visible} onHide={()=>props.setVisible(false)}>
            <Modal.Header className="custom-modal-header" closeButton>
                <Modal.Title>Impresión de comandas</Modal.Title>
            </Modal.Header>
            <Modal.Body>                
                <div style={styles.header}>
                    <h4 style={styles.title}>
                        🖨️ Imprimir Comandas por Categoría
                    </h4>
                </div>
                    
                <div style={styles.body}>

                    {
                        //Hay que controlar por un permiso igual...
                        Object.keys(comandasPorCategoria).length<=0&&props.printPermission ?
                            <p style={{textAlign: 'center'}}>
                                <a href="#" onClick={getRePrintComandas}>🖨️ Re-imprimir comandas</a>
                            </p>
                        :null
                    }                    

                    {tieneUnaCategoria && (
                        <div style={styles.alert}>
                        ℹ️ Solo hay una categoría de artículos. Puedes imprimir la comanda completa.
                        </div>
                    )}

                    <div style={styles.grid}>
                        {categorias.map(categoria => (
                        <div key={categoria} style={styles.card}>
                            <div style={styles.cardHeader}>
                            <h6 style={{margin: 0}}>{categoria}</h6>
                            <span style={styles.badge}>
                                {comandasPorCategoria[categoria].length} comanda(s)
                            </span>
                            </div>
                            
                            <div style={styles.cardBody}>
                            {comandasPorCategoria[categoria].map(comanda => (
                                <div key={comanda.sub_category_id} style={styles.listItem}>
                                <div style={styles.small}>
                                    Cuenta <strong>#{comanda.quote_no?comanda.quote_no:comanda.quotation_id}</strong>
                                </div>
                                <div style={styles.small}>
                                    Area <strong>{comanda.mesa_des}</strong> - {comanda.account_time}
                                </div>
                                <div style={{marginTop: '0.5rem'}}>
                                    {comanda.items.map((articulo, idx) => (
                                    <div key={idx} style={{fontSize: '0.875rem', marginBottom: '0.25rem'}}>
                                        <strong>{articulo.qty} {articulo.unit_des.toUpperCase()} x {articulo.product_des}</strong>
                                        {articulo.additionals && (
                                        <div style={{color: '#000', fontWeight: 'bold', fontSize: '0.75rem'}}>
                                            {articulo.additionals}
                                        </div>
                                        )}
                                        {articulo.item_note && (
                                        <div style={{color: '#000', fontWeight: 'bold', fontSize: '0.85rem'}}>
                                            Nota: {articulo.item_note}
                                        </div>
                                        )}
                                    </div>
                                    ))}
                                </div>
                                </div>
                            ))}
                            
                            {/* <div style={{marginTop: '1rem', paddingTop: '0.5rem', borderTop: '1px solid #dee2e6'}}>
                                <span style={styles.small}>
                                Total: $0
                                </span>
                            </div> */}
                            </div>
                            
                            {
                                // isRePrint?
                                    <div style={styles.cardFooter}>
                                        <button 
                                            style={{...styles.button, ...styles.buttonOutline, width: '100%'}}
                                            onClick={() => imprimirCategoria(categoria)}
                                        >
                                            🖨️ Imprimir {categoria}
                                        </button>
                                    </div>
                                // :null
                            }                            

                        </div>
                        ))}
                    </div>
                </div>
                    
                <div style={styles.footer}>
                    {/* <div>
                        <span style={styles.small}>
                        Total general: $0
                        </span>
                    </div> */}
                    
                    <div style={{display: 'flex', gap: '0.5rem'}}>
                        <button 
                        style={{...styles.button, ...styles.buttonSecondary}}
                        onClick={()=>props.setVisible(false)}
                        >
                        Cancelar
                        </button>
                        
                        {/* {tieneUnaCategoria ? (
                        <button 
                            style={{...styles.button, ...styles.buttonSuccess}}
                            onClick={() => imprimirCategoria(categorias[0])}
                        >
                            🖨️ Imprimir Comanda
                        </button>
                        ) : (                        
                        )} */}

                        <button 
                            style={{...styles.button, ...styles.buttonSuccess}}
                            onClick={imprimirTodas}
                        >
                            🖨️ Imprimir Comandas
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    },
    modal: {
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      maxWidth: '90vw',
      maxHeight: '90vh',
      width: '800px',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column'
    },
    header: {
      padding: '1rem 1.5rem',
      borderBottom: '1px solid #dee2e6',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: '#f8f9fa'
    },
    title: {
      margin: 0,
      fontSize: '1.25rem',
      fontWeight: '500'
    },
    closeButton: {
      background: 'none',
      border: 'none',
      fontSize: '1.5rem',
      cursor: 'pointer',
      padding: '0.25rem',
      color: '#6c757d'
    },
    body: {
      padding: '1.5rem',
      overflow: 'auto',
      flex: 1
    },
    footer: {
      padding: '1rem 1.5rem',
      borderTop: '1px solid #dee2e6',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: '#f8f9fa'
    },
    alert: {
      padding: '0.75rem 1rem',
      marginBottom: '1rem',
      border: '1px solid #b6d7ff',
      borderRadius: '0.375rem',
      backgroundColor: '#cff4fc',
      color: '#055160'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '1rem'
    },
    card: {
      border: '1px solid #dee2e6',
      borderRadius: '0.375rem',
      overflow: 'hidden',
      backgroundColor: 'white'
    },
    cardHeader: {
      padding: '0.75rem 1rem',
      backgroundColor: '#f8f9fa',
      borderBottom: '1px solid #dee2e6',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    cardBody: {
      padding: '1rem'
    },
    cardFooter: {
      padding: '0.75rem 1rem',
      backgroundColor: '#f8f9fa',
      borderTop: '1px solid #dee2e6'
    },
    badge: {
      padding: '0.25rem 0.5rem',
      fontSize: '0.75rem',
      fontWeight: '500',
      borderRadius: '0.375rem',
      backgroundColor: '#6c757d',
      color: 'white'
    },
    button: {
      padding: '0.375rem 0.75rem',
      border: '1px solid transparent',
      borderRadius: '0.375rem',
      fontSize: '0.875rem',
      fontWeight: '400',
      textAlign: 'center',
      cursor: 'pointer',
      textDecoration: 'none',
      display: 'inline-block'
    },
    buttonPrimary: {
      backgroundColor: '#0d6efd',
      borderColor: '#0d6efd',
      color: 'white'
    },
    buttonSecondary: {
      backgroundColor: '#6c757d',
      borderColor: '#6c757d',
      color: 'white'
    },
    buttonSuccess: {
      backgroundColor: '#198754',
      borderColor: '#198754',
      color: 'white'
    },
    buttonOutline: {
      backgroundColor: 'transparent',
      borderColor: '#0d6efd',
      color: '#0d6efd'
    },
    listItem: {
      padding: '0.5rem 0',
      borderBottom: '1px solid #f8f9fa'
    },
    small: {
      fontSize: '0.875rem',
      color: '#000'
    },
    textMuted: {
      color: '#6c757d'
    }
};

ModalComanda.propTypes = {
    comandas: PropTypes.array,
    visible: PropTypes.bool,
    setVisible: PropTypes.func,
    accountComandaSelected: PropTypes.number,
    setAccountComandaSelected: PropTypes.func,
    setComandas: PropTypes.func,
    printPermission: PropTypes.bool
}

export default ModalComanda